const PHOTO_EXTENSIONS = ["jpg", "jpeg", "png", "heic", "bmp", "gif", "tiff"];
const VIDEO_EXTENSIONS = ["mp4", "mov", "avi", "wmv", "mpeg"];
const FILE_EXTENSIONS = [
  "xlsx",
  "xls",
  "ods",
  "docx",
  "doc",
  "odt",
  "pptx",
  "ppt",
  "odp",
  "pdf",
  "rtf",
  "txt",
];

const EXTENSIONS = [
  ...PHOTO_EXTENSIONS,
  ...VIDEO_EXTENSIONS,
  ...FILE_EXTENSIONS,
];

export { PHOTO_EXTENSIONS, VIDEO_EXTENSIONS, FILE_EXTENSIONS, EXTENSIONS };
